import api from '../../api/_formulaire'


const state = () => ({
    professions: [],
    situationMatrimoniales: [],
    sexes: [],
    assurances: [], 
    civilites: [],
})

// getters
const getters = {
    situationMatrimoniales: (state) => {
        return state.situationMatrimoniales
    },
    sexes: (state) => {
        return state.sexes
    },

    assurances: (state) => {
        return state.assurances
    },

    civilites: (state) => {
        return state.civilites
    },
    professions: (state) => {
        return state.professions
    }
}

// actions
const actions = {

    getSituationsMatrimoniales({ commit }) {
        api.getSituationsMatrimoniales().then(
            response => {
                commit('SET_SITUATIONS', response)
            }
        )
    },

    getSexes({ commit }) {
        api.getSexes().then(
            response => {
                commit('SET_SEXES', response)
            }
        )
    },

    getAssurances({ commit }) {
        api.getAssurances().then(
            response => {
                commit('SET_ASSURANCES', response)
            }
        )
    },

    getCivilites({ commit }) {
        api.getCivilites().then(
            response => {
                commit('SET_CIVILITES', response)
            }
        )
    },

    getProfessions({ commit }) {
        api.getProfessions().then(
            response => {
                commit('SET_PROFESSIONS', response)
            }
        )
    },
}

// mutations
const mutations = {

    SET_SEXES(state, sexes) {
        state.sexes = sexes
    },

    SET_SITUATIONS(state, situationMatrimoniales) {
        state.situationMatrimoniales = situationMatrimoniales
    },

    SET_CIVILITES(state, civilites) {
        state.civilites = civilites
    },
    
    SET_ASSURANCES(state, assurances) {
        state.assurances = assurances
    },
    SET_PROFESSIONS(state, professions) {
        state.professions = professions
    },
    

}

export default {
  state,
  getters,
  actions,
  mutations
}
